import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import RichTextEditor from "react-rte";
import {ButtonMain} from "components";
import {httpRequestsOnSuccessActions, legsActions} from "store";
import {FindLoad, FindSuccessItem, useSecondaryModal} from "utils";
import {Editor} from "./editor";
import {Svg} from "assets";


export const AddNotes = ({item, legId, tripId}) => {
    const ACTION_TYPE = item ? "EDIT_LEG_NOTE" : "CREATE_LEG_NOTE";
    const [inputs, setInputs] = useState({});
    const [error, setError] = useState("");
    const dispatch = useDispatch();
    const {closeSecondary} = useSecondaryModal();
    const success = FindSuccessItem(ACTION_TYPE);
    const loading = FindLoad(ACTION_TYPE);

    useEffect(() => {
        if (item) {
            const params = {
                ...item,
            };

            params.note = RichTextEditor.createValueFromString(item?.text, "html");
            setInputs(params);
        }
    }, [item]);

    useEffect(() => {
        if (success?.type === ACTION_TYPE) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            closeSecondary();
        }
    }, [success]);

    const handleSubmit = () => {
        if (inputs?.note) {
            const editParams = {
                text: inputs?.note?.toString("html"),
            };

            if (item?._id || item?.id) {
                dispatch(legsActions.editLegNote(legId, item?._id || item?.id, editParams, tripId));
            } else {
                dispatch(legsActions.creteLegNote(legId, editParams, tripId));
            }
        } else {
            setError(!inputs?.note ? "note" : "");
        }
    };

    const handleCancel = () => {
        setError("");
        setInputs({});
        closeSecondary();
    };

    return (
        <div className="note-modal-wrapper">
            <div className="modal-header-main">
                <h3 className="modal-header-title">{item ? "Edit" : "Add New"} Note</h3>

                <button
                    className="modal-close-btn-main"
                    type="button"
                    onClick={closeSecondary}
                >
                    <Svg.CloseSvg/>
                </button>
            </div>

            <div className="modal-body-main">
                <Editor
                    inputs={inputs}
                    setInputs={setInputs}
                    error={error}
                    setError={setError}
                />
            </div>

            <div className="modal-footer-main">
                <ButtonMain
                    text="Cancel"
                    cancel
                    buttonMainStyles={{
                        width: "fit-content",
                    }}
                    onClick={handleCancel}
                />
                <ButtonMain
                    onClick={handleSubmit}
                    text={item ? "Save" : "Add"}
                    load={!!loading?.length}
                    buttonMainStyles={{
                        width: "80px",
                    }}
                />
            </div>
        </div>
    );
};
